var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 235,
    viewBox: "0 0 240 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1497_92801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.463 46.3413C153.463 46.3413 185.476 62.3682 199.412 98.1773L160.172 100.39L153.463 46.3413Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M160.172 100.39L153.463 46.3413C153.463 46.3413 185.476 62.3682 199.412 98.1773",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M120.729 235.253C186.854 235.253 240.459 229.277 240.459 221.906C240.459 214.534 186.854 208.559 120.729 208.559C54.6047 208.559 1 214.534 1 221.906C1 229.277 54.6047 235.253 120.729 235.253Z",
    fill: "#C9D3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1242 137.935H41.9756V218.455H58.1242V137.935Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.031 137.935H181.883V218.455H198.031V137.935Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.125 105.861H26.5776C21.7567 105.861 17.8486 109.769 17.8486 114.59V149.526C17.8486 154.347 21.7567 158.255 26.5776 158.255H211.125C215.946 158.255 219.854 154.347 219.854 149.526V114.59C219.854 109.769 215.946 105.861 211.125 105.861Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M69.4316 158.255H183.112C183.112 158.255 174.586 147.811 176.474 135.103C178.361 122.395 192.785 111.22 192.785 111.22L166.577 104.846L123.531 109.86L83.7736 107.261L69.4316 158.255Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.721 38.526C116.721 38.526 69.1577 44.1187 73.4207 72.1327C77.6837 100.147 102.429 149.902 102.429 149.902L154.479 147.253C154.479 147.253 167.44 87.6317 168.689 72.1428C169.937 56.6539 149.749 34.0905 116.721 38.526Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.104 171.268H22.5988C19.9754 171.268 17.8486 173.394 17.8486 176.018V183.072C17.8486 185.695 19.9754 187.822 22.5988 187.822H215.104C217.727 187.822 219.854 185.695 219.854 183.072V176.018C219.854 173.394 217.727 171.268 215.104 171.268Z",
    fill: "#E8ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.454 15.1401L116.73 38.5257L128.819 51.7512L133.255 24.8232L128.454 15.1401Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M132.737 29.0659C131.162 28.0947 129.906 26.6832 129.124 25.0059C129.124 25.0059 127.875 29.6343 131.458 35.7243L132.737 29.0659Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.187 16.6322C140.187 16.6322 139.517 24.5898 137.305 29.5735C136.861 30.5417 136.056 31.2971 135.061 31.6768C134.066 32.0566 132.962 32.0302 131.986 31.6035C129.489 30.4565 126.454 28.1728 126.292 23.859L125.114 16.5409C125.036 15.059 125.419 13.5893 126.209 12.3335C127 11.0777 128.16 10.0974 129.53 9.52725C134.524 7.13185 140.837 11.8008 140.187 16.6322Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.507 21.6162L141.182 25.0266C141.275 25.2204 141.318 25.4345 141.308 25.6493C141.297 25.8642 141.233 26.0729 141.121 26.2565C141.009 26.4402 140.852 26.5928 140.666 26.7007C140.48 26.8085 140.27 26.8681 140.055 26.8739H136.949L139.507 21.6162Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.054 24.5797L123.358 13.7294C123.358 13.7294 117.837 11.0193 120.699 7.7409C123.561 4.46245 125.145 7.6597 126.505 3.32565C127.865 -1.0084 131.671 -0.846005 133.468 2.31065C135.264 5.4673 135.092 1.73209 138.36 2.17869C141.628 2.62529 142.045 4.27974 141.405 6.67514C140.766 9.07054 146.044 7.8627 146.318 11.2122C146.592 14.5617 145.912 17.5356 137.974 15.7391C130.037 13.9425 133.762 22.0219 123.054 24.5797Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.666 21.9306C130.666 21.9306 131.123 18.8856 128.809 18.7334C126.495 18.5811 125.764 22.9659 128.809 23.8997L130.666 21.9306Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M95.608 59.6885C95.608 59.6885 110.112 71.8685 108.407 100.39C106.702 128.911 132.767 148.359 132.767 148.359L102.459 149.902C102.459 149.902 92.0352 128.404 87.4373 116.407C82.8393 104.409 95.608 59.6885 95.608 59.6885Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.865 112.895C202.416 110.235 203.157 96.6546 193.88 93.1529L193.637 93.0717C185.598 90.1891 151.25 96.5735 151.25 96.5735C151.25 96.5735 136.36 93.5284 137.04 99.7199C137.72 105.911 144.267 108.703 152.844 103.536C152.793 103.536 173.763 118.203 192.865 112.895Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.529 95.9936L153.043 95.5898L152.23 104.623L156.716 105.027L157.529 95.9936Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3047 86.2713L52.9477 165.837C52.9477 165.837 42.7064 165.604 43.2748 171.267H63.7575C63.7575 171.267 95.8924 105.292 95.6082 84.495C95.324 63.6977 73.6233 58.5719 68.3047 86.2713Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.656 100.116C155.304 100.116 156.64 98.7801 156.64 97.132C156.64 95.484 155.304 94.1479 153.656 94.1479C152.008 94.1479 150.672 95.484 150.672 97.132C150.672 98.7801 152.008 100.116 153.656 100.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0853 61.9519C67.9291 69.7877 62.1233 82.4041 60.6211 100.705L92.7661 109.84C92.7661 109.84 102.652 84.4646 99.526 67.2806C97.1915 54.451 80.2309 51.0508 73.0853 61.9519Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M73.0853 61.9519C67.9291 69.7877 62.1233 82.4041 60.6211 100.705L92.7661 109.84C92.7661 109.84 102.652 84.4646 99.526 67.2806C97.1915 54.451 80.2309 51.0508 73.0853 61.9519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.429 149.902L88.2189 165.248C85.8282 167.825 84.1476 170.979 83.3416 174.4C82.5356 177.822 82.6319 181.394 83.621 184.767L92.2992 214.385L100.135 214.659L98.2268 185.924C98.0527 183.243 98.8264 180.585 100.413 178.416C101.999 176.248 104.297 174.705 106.905 174.059L112.193 172.749C116.51 171.678 120.941 171.139 125.388 171.146C137.132 171.146 159.766 172.161 165.856 179.55C174.2 189.629 188.186 216.932 188.186 216.932L195.778 212.385C195.778 212.385 185.913 159.097 154.438 147.252L102.429 149.902Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.952 215.897L192.449 221.155L202.01 218.424C202.44 218.294 202.817 218.031 203.09 217.674C203.362 217.317 203.515 216.883 203.527 216.435C203.539 215.986 203.41 215.544 203.158 215.173C202.906 214.801 202.544 214.519 202.122 214.364C199.502 213.341 196.649 213.063 193.88 213.563L189.952 215.897Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6185 214.466C92.077 214.689 90.5697 215.105 89.1322 215.704C88.6371 215.918 88.231 216.297 87.9824 216.776C87.7339 217.255 87.658 217.804 87.7677 218.333C87.8774 218.861 88.1659 219.335 88.5846 219.675C89.0033 220.016 89.5265 220.201 90.066 220.201H99.7288L98.998 214.466H93.6185Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.765 50.6043C221.791 50.6043 233.161 39.9115 233.161 26.7213C233.161 13.5311 221.791 2.83838 207.765 2.83838C193.74 2.83838 182.37 13.5311 182.37 26.7213C182.37 39.9115 193.74 50.6043 207.765 50.6043Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.789 31.4917L179.071 52.2078L199.899 38.6677L193.789 31.4917Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.253 38.5867C214.806 38.5867 220.118 33.2744 220.118 26.7213C220.118 20.1683 214.806 14.856 208.253 14.856C201.7 14.856 196.388 20.1683 196.388 26.7213C196.388 33.2744 201.7 38.5867 208.253 38.5867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.253 20.4995V27.5538L213.45 27.1376",
    stroke: "#29333D",
    strokeWidth: 1.015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1497_92801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 235,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.687a5ea50d17f5ffcd581598d284e5bf.svg";
export { ForwardRef as ReactComponent };